import React from 'react';

import { DefectCatalogItem } from 'domain/surveyDataManager/contracts';
import type { ActiveDefectLayerId } from 'state/surveyDataManager/activeLayersSlice';

import {
  deriveParameterOptionsForDefectGroup,
  isWizardDefectGroupFullyActive,
} from '../wizardLogic';

export interface WizardStepDefectProps {
  readonly defects: readonly DefectCatalogItem[];
  readonly surveyType: string | null;
  readonly defectGroups: readonly string[];
  readonly activeLayerIds: ReadonlySet<ActiveDefectLayerId>;
  readonly selectedDefectGroup: string | null;
  readonly onSelectDefectGroup: (defectGroup: string) => void;
}

function WizardStepDefect({
  defects,
  surveyType,
  defectGroups,
  activeLayerIds,
  selectedDefectGroup,
  onSelectDefectGroup,
}: WizardStepDefectProps): JSX.Element {
  return (
    <div className="sdm-add-layer-wizard__panel">
      <h4 className="sdm-add-layer-wizard__panel-title">Choose parameter group</h4>
      <div className="sdm-add-layer-wizard__card-grid sdm-add-layer-wizard__card-grid--defects">
        {defectGroups.length === 0 ? (
          <p className="sdm-add-layer-wizard__hint" role="status">
            No parameter groups are available for this survey type.
          </p>
        ) : null}
        {defectGroups.map((defectGroup) => {
          const isSelected = selectedDefectGroup === defectGroup;
          const parameterCount = deriveParameterOptionsForDefectGroup(
            defects,
            surveyType,
            defectGroup,
          ).length;
          const isDisabled = isWizardDefectGroupFullyActive(
            activeLayerIds,
            defects,
            surveyType,
            defectGroup,
          );

          return (
            <button
              key={defectGroup}
              type="button"
              className={`sdm-add-layer-wizard__card sdm-add-layer-wizard__card--defect${
                isSelected ? ' sdm-add-layer-wizard__card--selected' : ''
              }${isDisabled ? ' sdm-add-layer-wizard__card--disabled' : ''}`}
              onClick={() => onSelectDefectGroup(defectGroup)}
              disabled={isDisabled}
              aria-disabled={isDisabled || undefined}
              aria-pressed={isSelected}
            >
              <strong>
                {defectGroup}
                {isDisabled ? ' (already active)' : ''}
              </strong>
              <span className="sdm-add-layer-wizard__card-meta">
                {parameterCount} parameter{parameterCount === 1 ? '' : 's'}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default WizardStepDefect;
